import { useCallback, useMemo, useRef, useState } from 'react';
import { computeRowBalance, sortRowsByAccount } from '../services/MatchingService';
import { normalizeBookingProposal } from '../services/BookingProposalService';

/**
 * Shared proposal-review state for manual, bank, and Skatteverket entry
 * points. Rendering remains owned by each surface; selection, editable rows,
 * balance state, and the proposal/outcome link live here.
 */
export default function useBookingProposalReview(context = {}) {
    const [proposal, setProposal] = useState(null);
    const [rows, setRows] = useState([]);
    const contextRef = useRef(context);
    contextRef.current = context;

    const selectProposal = useCallback((candidate) => {
        const normalized = normalizeBookingProposal(candidate, contextRef.current);
        setProposal(normalized);
        setRows(sortRowsByAccount((normalized?.rows || []).map((row) => ({ ...row }))));
        return normalized;
    }, []);

    const startManual = useCallback((initialRows = []) => {
        setProposal(null);
        setRows(sortRowsByAccount(initialRows.map((row) => ({ ...row }))));
    }, []);

    const reset = useCallback(() => {
        setProposal(null);
        setRows([]);
    }, []);

    const balance = useMemo(() => computeRowBalance(rows), [rows]);

    return {
        proposal,
        rows,
        setRows,
        selectProposal,
        startManual,
        reset,
        balance,
    };
}
